import styled from 'styled-components';
import { LinkButtonStyledProps } from './LinkButton.types';

const LinkButton = styled.button<LinkButtonStyledProps>`
  ${({ theme }) => theme.components.linkButton.base};
  ${({ theme, intent }) => theme.components.linkButton.intent[intent]};
  width: auto;
  cursor: pointer;
  padding: 0;
  align-items: center;
  display: inline-flex;
  flex-direction: ${({ orientation }) =>
    orientation === 'vertical' ? 'column' : 'row'};
  gap: ${({ orientation, theme }) =>
    orientation === 'vertical' ? '0' : theme.spacing.S2};
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  vertical-align: inherit;
`;

const Leading = styled.div`
  height: 100%;
  line-height: 0;
  overflow: hidden;
`;

const Trailing = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  line-height: 0;
  overflow: hidden;
`;

export { LinkButton, Leading, Trailing };
